import { action, observable, runInAction } from 'mobx';

import { orderOfferController } from './orderOfferController';

import {
  OrderOfferStartRequest,
  OrderOfferItem,
} from '../../api/orderOffer';

export interface OrderOfferStore {
  orderOffers: OrderOfferItem[],
  // orderOfferStartRequest: OrderOfferStartRequest,
  error: any,
}

export const orderOfferStore: OrderOfferStore = observable({
  orderOffers: [],
  error: null,
} as OrderOfferStore);

export const orderOfferActions = {

  getOrderOffer: async (): Promise<void> => {
    const response = await orderOfferController.getOrderOffer();
    orderOfferActions.handleError(response);
    runInAction(() => {
      orderOfferStore.orderOffers = response.data ?? [];
    });
  },

  startOrderOffer: async (request: OrderOfferStartRequest): Promise<void> => {
    const response = await orderOfferController.startOrderOffer(request);
    orderOfferActions.handleError(response);
  },

  restartOrderOffer: async (request: OrderOfferStartRequest): Promise<void> => {
    const response = await orderOfferController.restartOrderOffer(request);
    orderOfferActions.handleError(response);
  },

  manualOrderProcessing: async (request: OrderOfferStartRequest): Promise<void> => {
    const response = await orderOfferController.manualOrderProcessing(request);
    orderOfferActions.handleError(response);
  },

  acceptOrderOffer: async (orderId: string): Promise<void> => {
    const response = await orderOfferController.acceptOrderOffer(orderId);
    orderOfferActions.handleError(response);
    orderOfferActions.getOrderOffer();
  },

  rejectOrderOffer: async (orderId: string): Promise<void> => {
    const response = await orderOfferController.rejectOrderOffer(orderId);
    orderOfferActions.handleError(response);
    orderOfferActions.getOrderOffer();
  },

  clearOrderOffers: action(() => {
    orderOfferStore.orderOffers = [];
  }),

  clearError: action(() => {
    orderOfferStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      orderOfferStore.error = errorData;
      throw errorData;
    }
  }),

};
